var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "url(#pattern0_261_276)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_261_276",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_261_276",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_261_276",
    width: 100,
    height: 100,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEJElEQVR4nO2dO2tUQRiGTyIaiSRCAkbwAtFCJeAFTQTx0kSt/AMW6az9CW5pq11aKwl2GjUQYxOjhZdCTREt1OAFDSgkGjWaR8YdybLumXNO9uw5c779XhhIsZmZ53vn9rHsTBCoVCqVSqVS+SJgjSl590MV/DXjAPAAeAIc1qDkJGAjcAn4xYp+A1eAbjUmWzPOALOE6z0wBLSoMY01Yidwm/i6C+xRU9I3og24ACyGBP6rLbW0aP+3TY1Jx4wTwLRjFtwAeoEtwDXH514Cp9WU1Rux2W7QyyEBfmv2iZD95ZXDmOvAVjUmvhGtdkOeCwnokj1ddTjqaAdKwI+QOr4A5zV3iTZjP3DfMbofAocSmLsXuOeo7zEwoLPl/8BtAC5W5RSV+mxHdGvS4Jmjr51xn0LqNrnLMNCpxqys+W8co3gE2FRvsIAuG/hlV+7StKYAO4BbDiNmgJMNaPcY8MzR7gSwO2gWAWvt8rMQEpBvdkNuy6AP847cxfRhfdAEOcVzx+i8A+zKsD8mfxl19OcFcCqQJqAnIqd4l+f6TXkfey0+d6k44UTlFLmfcIjOXf6d9Ir5vQuwLyKneAT0B56Jcu4yFdHvgSLmFEtFHWlIyV1irMUmp+gJCiKic5dc976onOJmxGkl9ZwiKwHHI06HE1meDr3OKbKS96wxRk2mOUXGq8GoN6tBYddVqfulnZbFPXlke6Is5WVIsc7mjcm5pnwxZHw131MI/aZz3AdDRhreaEFk9w01xBepIZ5JDfFMaohnUkM8kxrimdQQz6SGeCY1xDOpIZ5JDfFMaohnUkM8kxrimdQQz6SGeCY1xDOJMaQGSB5qBIcaUofUEJ0hKUiXrOZcsoaBgw0upg1dsnwZWWQzsMTMkFI6vZXPIQYEIRxiQBDCIQYEIRxiQBDCIQYEIRxiQBDCIQYEIRxiQBDCIQYEIRxiQBDCIQYEIRxiQBDCIQYEIRxiQBDCIQYEIRxiQBDCIQYEIRxiQBDCIQYEIRxiQBDCIQYEIRxiQBDCIQYEIRxiQBDCIQYEIRxiQBDCUQtk1nYkSdmWJghwxJQ0DTF9XAXXrC+3kiZVX72GUL500tydO1n1ittQnIv+YxjSlwKnfEOAdTbo0xGvepprwdsTcKghSQwBOm2QzQufcfXRBr5bsiGD9jbnekpPXEMovxN12XEJfhwt2Dp6ExjSkwLnYFBE1TKE8q+crjqu8a58rfOsLeZvl5ZsnaZuvX84gSFzEYE1DwGM1RqBdgaPOR4LCGtDL4R2GBKmn/az/THfkjK/I/xOPKkhCQyZt6+5bV/lM+Al+/aVGlKnIR9sMLtSaKPDntKqkzedITEMmbHBS/3p04o85qkaEm3IpM2+WzJq96h9xVP3kKrAnMvzkUmg3/Qhr/ZVKpVKpQpS0B9QE9rXAAgCyQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.71a3f64ecb1dc033c0694742dfc16b2b.svg";
export { ForwardRef as ReactComponent };